import { useEffect, useState } from 'react';
import { Alert, Box } from '@mui/material';
import { DialogContainer, DialogTitle, DialogBody, DialogActions, CustomTextField } from '../../../common';
import { getSupplyOrderApiErrorMessage } from '../utils/supplyOrdersUtils';

const SupplyOrderActionDialog = ({
  open,
  onClose,
  title,
  description,
  confirmLabel = 'Confirmar',
  requireReason = false,
  requireEmail = false,
  onConfirm,
  isProcessing = false,
}) => {
  const [reason, setReason] = useState('');
  const [recipientEmail, setRecipientEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (open) {
      setReason('');
      setRecipientEmail('');
      setErrorMessage('');
    }
  }, [open]);

  const handleConfirm = async () => {
    if (requireReason && !reason.trim()) {
      setErrorMessage('El motivo es requerido.');
      return;
    }

    try {
      setErrorMessage('');
      await onConfirm({
        reason: reason.trim() || undefined,
        recipient_email: recipientEmail.trim() || undefined,
      });
      onClose();
    } catch (error) {
      setErrorMessage(getSupplyOrderApiErrorMessage(error));
    }
  };

  if (!open) return null;

  return (
    <DialogContainer open={open} onClose={onClose} size="small">
      <DialogTitle>{title}</DialogTitle>
      <DialogBody>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {description && <Alert severity="info">{description}</Alert>}
          {errorMessage && <Alert severity="error">{errorMessage}</Alert>}

          {requireReason && (
            <CustomTextField
              label="Motivo"
              value={reason}
              onChange={(event) => setReason(event.target.value)}
              multiline
              minRows={2}
              fullWidth
              required
            />
          )}

          {requireEmail && (
            <CustomTextField
              label="Email del destinatario (opcional)"
              value={recipientEmail}
              onChange={(event) => setRecipientEmail(event.target.value)}
              type="email"
              fullWidth
            />
          )}
        </Box>
      </DialogBody>
      <DialogActions
        handleClose={onClose}
        handleSave={handleConfirm}
        saveLabel={confirmLabel}
        saveButtonProps={{ isLoading: isProcessing }}
      />
    </DialogContainer>
  );
};

export default SupplyOrderActionDialog;
